import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuthToken } from '../utils/auth';

const ProtectedRoute = ({ children }) => {
  const token = getAuthToken();

  if (!token) {
    console.log("ProtectedRoute - No token, redirecting to login.");
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
